// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39SOs","questions":"styles_questions__RjuFf","footer":"styles_footer__XSbLr"};